import React from 'react';
import PropTypes from "prop-types";
import MiscUtils from "../../../qwc2/utils/MiscUtils";
import ConfigUtils from "../../../qwc2/utils/ConfigUtils";
import axios from "axios";
import LocaleUtils from "../../../qwc2/utils/LocaleUtils";
import geojsonBbox from 'geojson-bounding-box';
import Moment from "moment";
import keycloakMgr from "../../Keycloak";
import FileUtils from "../../utils/FileUtils";

export default class AbstractTab extends React.Component {

    static propTypes = {
        addDetailWindow: PropTypes.func,
        changeZoomLevel: PropTypes.func,
        map: PropTypes.object,
        panTo: PropTypes.func,
        removeDetailWindow: PropTypes.func,
        setDetailWindow: PropTypes.func,
        tab: PropTypes.object,
        windowId: PropTypes.string,
        windowType: PropTypes.string,
        zoomToExtent: PropTypes.func
    }

    parsedContent = (text) => {
        text = text.replace('&#10;', '<br />');
        return text;
    }

    hideProperty = (value, hide) => {
        if (hide) {
            if (hide.indexOf("null") > -1 && value === null) {
                return true;
            }
            if (hide.indexOf("empty") > -1 && value === "") {
                return true;
            }
        }
        return false;
    }

    addPrefixPostfix = (value, config) => {
        if (value === '') {
            return value;
        }
        if (config && config.prefix) {
            value = config.prefix + value;
        }
        if (config && config.postfix) {
            value = value + config.postfix;
        }
        return value;
    }

    attribValue = (value, config) => {
        let format = "default";
        if (config && config.format) {
            format = config.format;
        }
        if (value === null) {
            value = '';
        } else {
            value = this.formatAttributeValue(value, format);
        }
        value = this.addPrefixPostfix(value, config);
        return value;
    }

    loadImageWithAuth(url, callback) {
        const config = {
            method: 'get',
            url: url,
            responseType: 'arraybuffer',
            headers: {}
        };
        keycloakMgr.addHeader(config);

        axios(config).then(response => {
            const reader = new FileReader();
            reader.onload = function (e) {
                callback(e.target.result);
            };
            reader.readAsDataURL(new Blob([response.data], {
                type: 'image/png'
            }));
        }).catch(error => {
            console.log("Error *** : " + error);
        });
    }

    formatAttributeValue = (text, format) => {
        switch (format) {
            case 'float1':
                return this.formatNumber(text, 1);
            case 'float2':
                return this.formatNumber(text, 2);
            case 'float3':
                return this.formatNumber(text, 3);
            case 'float4':
                return this.formatNumber(text, 4);
            case 'date':
                if (text === null || text === '' || typeof (text) === 'undefined') {
                    return '';
                }
                Moment.locale('de');
                return Moment(text).format('DD.MM.YYYY');
            case 'boolean':
                if (text === true || text === "true") {
                    return LocaleUtils.tr("basic.yes");
                } else {
                    return LocaleUtils.tr("basic.no");
                }
            case 'html':
                return <span dangerouslySetInnerHTML={{__html: MiscUtils.addLinkAnchors(text)}}></span>;
            default:
                text = "" + text; // Ensure text is a string
                text = MiscUtils.addLinkAnchors(text);
                return this.parsedContent(text);
        }
    }

    linkEmail = (value) => {
        const link = "mailto:" + MiscUtils.htmlEncode(value);
        return (
            <a href={link}>
                {MiscUtils.htmlEncode(value)}
            </a>
        );
    }

    linkPhone = (value) => {
        const link = "tel:" + MiscUtils.htmlEncode(value);
        return (
            <a href={link}>
                {MiscUtils.htmlEncode(value)}
            </a>
        );
    }

    formatNumber = (value, precision) => {
        if (typeof value === 'undefined' || value === '' || value === null) {
            return '';
        }
        if (typeof value === 'string') {
            value = parseFloat(value);
        }

        const formatter = new Intl.NumberFormat('de-DE', {
            minimumFractionDigits: precision
        });
        return formatter.format(value);
    }

    goToObject(id, type) {
        const url = ConfigUtils.getConfigProp("featureServiceUrl") + '/' + type + '/items/' + id;
        this.goToObjectUrl(url);
    }

    async zoomTo(feature) {
        if (this.hasGeometry(feature)) {
            const extend = geojsonBbox(feature);
            await this.props.zoomToExtent(extend, 'EPSG:4326', -2);
        }
    }

    panTo(feature) {
        if (this.hasGeometry(feature)) {
            const bounds = geojsonBbox(feature);
            const center = [0.5 * (bounds[0] + bounds[2]), 0.5 * (bounds[1] + bounds[3])];
            this.props.panTo(center, 'EPSG:4326');
        }
    }

    hasGeometry(feature) {
        return (feature && feature.geometry);
    }

    goToObjectUrl(url) {
        const self = this;
        axios(url).then(response => {
            if (response.data.features && response.data.features[0]) {
                self.props.setDetailWindow(self.props.windowId, response.data.features[0]);
            } else if (response.data.properties) {
                self.props.setDetailWindow(self.props.windowId, response.data);
            }
        }).catch(error => {
            console.log("Error *** : " + error);
        });
    }

    openComponentUrl(url) {
        const self = this;
        axios(url).then(response => {
            if (response.data.features && response.data.features[0]) {
                self.openComponent(response.data.features[0], url);
            } else if (response.data.properties) {
                self.openComponent(response.data, url);
            }
        }).catch(error => {
            console.log("Error *** : " + error);
        });
    }

    openComponent(component, url) {
        component.detailWindowType = 'component';
        component.detailWindowUrl = url;
        console.log('Open component', this.props.windowType, component);
        if (this.props.windowType === 'component') {
            this.props.setDetailWindow(this.props.windowId, component);
        } else {
            this.props.addDetailWindow(component);
        }
    }

    renderLinkTitle(item, objectType) {
        if (item.links) {
            for (let i = 0; i < item.links.length; i++) {
                const link = item.links[i];
                if (link.objectType === objectType) {
                    return link.title;
                }
            }
        }
        return null;
    }

    downloadFile(downloadName, downloadContent) {
        FileUtils.download(downloadName, downloadContent);
    }

    useAuth() {
        if (this.props.tab.config && this.props.tab.config.auth) {
            return this.props.tab.config.auth;
        }
        return false;
    }

    renderImage(url, width, height, href) {
        if (typeof (width) === 'undefined') {
            width = 50;
        }
        if (typeof (height) === 'undefined') {
            height = 50;
        }
        const style = {
            width: '100%',
            maxWidth: width + "px",
            maxHeight: height + "px"
        };
        if (typeof (href) === 'undefined') {
            return (
                <span>
                    <img src={url} style={style}/>
                </span>
            );
        } else {
            return (
                <a href={href} target="_blank">
                    <img src={url} style={style}/>
                </a>
            );
        }
    }

}
